export default __webpack_public_path__ + "static/img48v-e4ebb44ca0bac43f904a83187a05be9c.jpg";